import { render, staticRenderFns } from "./EditPriceRules.vue?vue&type=template&id=8b479dfc"
import script from "./EditPriceRules.vue?vue&type=script&lang=js"
export * from "./EditPriceRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports